/**
 * Функция для установки значения в ref, не зависимо от его типа
 *
 * @export
 * @template T
 * @param {React.Ref<T>} ref
 * @param {T} value
 */
export function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}